/**
 * /en/admin/structure/types/manage/find_a_provider_results/fields
 */
import Element from "../core/element.es6.js";
import Field from "../core/field.es6.js";
import LinkField from "../core/link-field.es6.js";

export default class FindAProviderResultsContentType extends Element {
  get applyFilterLabel() {
    return new Field({
      machineName: 'field_apply_filter_label',
      parentElement: this,
    });
  }

  get awayLabel() {
    return new Field({
      machineName: 'field_away_label',
      parentElement: this,
    });
  }

  get callLabel() {
    return new Field({
      machineName: 'field_call_label',
      parentElement: this,
    });
  }

  get clearLabel() {
    return new Field({
      machineName: 'field_clear_label',
      parentElement: this,
    });
  }

  get countLabel() {
    return new Field({
      machineName: 'field_count_label',
      parentElement: this,
    });
  }

  get hideLocationsLabel() {
    return new Field({
      machineName: 'field_hide_locations',
      parentElement: this,
    });
  }

  get inPersonOnlineSchedulingAvailableOptionLabel() {
    return new Field({
      machineName: 'field_os_in_person_option_label',
      parentElement: this,
    });
  }

  get inPersonOrTelemedicineOnlineSchedulingAvailableOptionLabel() {
    return new Field({
      machineName: 'field_os_all_option_label',
      parentElement: this,
    });
  }

  get milesLabel() {
    return new Field({
      machineName: 'field_miles_label',
      parentElement: this,
    });
  }

  get ofLabel() {
    return new Field({
      machineName: 'field_of_label',
      parentElement: this,
    });
  }

  get onlineSchedulingOptionsFilterLabel() {
    return new Field({
      machineName: 'field_os_options_filter_label',
      parentElement: this,
    });
  }

  get pageLabel() {
    return new Field({
      machineName: 'field_page_label',
      parentElement: this,
    });
  }

  get scheduleAnAppointmentLink() {
    return new LinkField({
      machineName: 'field_schedule_online_link',
      parentElement: this,
    });
  }

  get searchPlaceholder() {
    return new Field({
      machineName: 'field_search_placeholder',
      parentElement: this,
    });
  }

  get showMoreLocationsEnd() {
    return new Field({
      machineName: 'field_show_more_locations_end',
      parentElement: this,
    });
  }

  get showMoreLocationsSingle() {
    return new Field({
      machineName: 'field_show_more_locations_single',
      parentElement: this,
    });
  }

  get showMoreLocationsStart() {
    return new Field({
      machineName: 'field_show_more_locations_start',
      parentElement: this,
    });
  }

  get specialtyFilterLabel() {
    return new Field({
      machineName: 'field_specialty_filter_label',
      parentElement: this,
    });
  }

  get telemedicineOnlineSchedulingAvailableOptionLabel() {
    return new Field({
      machineName: 'field_os_telemed_option_label',
      parentElement: this,
    });
  }

  constructor() {
    super({ selector: '.provider-results-grid--wrapper' });
  }
}
